
        import '/home/builduser/.yarn/berry/cache/@wix-design-system-npm-1.104.2-241b209bf9-10.zip/node_modules/@wix/design-system/styles.global.css.css.virtualfile';
        module.exports = {};